module.exports = __webpack_public_path__ + "static/img/file-ppt.cc62bf18.svg";